import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { BaseButtonOutline } from '..';
import { ProtectedImage } from '../ProtectedImage/ProtectedImage';
import { ProtectedDownloadHandler } from '../ProtectedDownloadHandler/ProtectedDownloadHandler';
import { FORM_VARIANT } from '../../constants/form.constant';
import './ClientAdvisorBadge.scss';

export const ClientAdvisorBadge = ({ clientId, image, href, variant }) => {
  const { t: common } = useTranslation('common');
  const filename = `badge-client-advisor-${clientId}.zip`;
  const { REQUEST_DETAILS } = FORM_VARIANT;

  const isRequestDetails = variant === REQUEST_DETAILS;

  const renderBadge = () => (
    <>
      <ProtectedImage src={image} className="client-advisor-badge__image" />
      <ProtectedDownloadHandler filename={filename} href={href}>
        {({ onClick }) => (
          <BaseButtonOutline
            onClick={onClick}
            small
            left={!isRequestDetails}
            iconRight={!isRequestDetails}
            iconLeft={isRequestDetails}
            icon="curved-arrow-down"
            className={`multiline-button client-advisor-badge__download-button`}
            data-testid="client-advisor-badge-download-button"
          >
            {common('request.details.downloadBadge')}
          </BaseButtonOutline>
        )}
      </ProtectedDownloadHandler>
    </>
  );

  return (
    <div className={classnames('client-advisor-badge', { [`client-advisor-badge--${variant}`]: isRequestDetails })}>
      <p className="client-advisor-badge__title">{common('request.details.badge')}</p>

      {isRequestDetails ? <div className="client-advisor-badge__wrapper">{renderBadge()}</div> : renderBadge()}
    </div>
  );
};

export default ClientAdvisorBadge;
